import {useState, useEffect} from 'react';

import {useParams} from 'react-router';

import {getPublicCertificationBodies} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

const useGetCBs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  const {abId} = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async (isAuth) => {
    setIsLoading(true);
    try {
      const response = await getPublicCertificationBodies({
        accreditation_bodies_id: abId,
        limit: isAuth ? -1 : 4,
        inAbDetail: true,
      });
      const {data, meta} = response;
      setData(data);
      setMeta(meta);
    } catch (error) {
      alertByError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    meta,
    isLoading,
    reload: getData,
  };
};

export default useGetCBs;
